import styled from "styled-components";

export const Image = styled.img`
  width: 170px;
  height: 24px;

  @media (max-width: 340px) {
    width: 136px;
    height: 19.2px;
  }
`;
